import { ConversationEditInput } from '@modules/conversation-message/ConversationEditInput';
import { ConversationMessageEditor } from '@modules/conversation-message/ConversationMessageEditor';
import { useConversationEditorExtensions } from '@modules/conversation/hooks/useConversationEditorExtensions';
import { forwardRef, useEffect } from 'react';
import { IConversationMessage } from 'src/@types/conversation';
import { useLocales } from 'src/locales';
import { useGatheringChatMessageEditMutation } from '../mutations';
import { useGatheringChatContext } from '../useGatheringChatContext';

const InputComponent = forwardRef((props: any, ref) => (
  <ConversationMessageEditor {...props} ref={ref} />
));

type Props = {
  message: IConversationMessage;
  cancelEdition: () => void;
};

export const GatheringChatEditInput = ({ message, cancelEdition }: Props) => {
  const { sessionRef, participants } = useGatheringChatContext();
  const { translate } = useLocales();

  const { editGatheringChatMessage } = useGatheringChatMessageEditMutation();

  // Editor exclusivo para a edição. Não pegar do contexto.
  const { editor } = useConversationEditorExtensions({
    conversationId: sessionRef,
    mentionableParticipants: participants,
    placeholder: translate('collaborate.board.edit_message'),
  });

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (!editor || !message.content) return;
    editor.commands.setContent(message.content);
    editor.commands.focus();
  }, [editor]);

  const onSend = async () => {
    if (!editor || editor.isEmpty) return;

    const editedMessage = editor.getHTML();
    if (!editedMessage) return;
    await editGatheringChatMessage({
      sessionRef,
      messageId: message._id,
      content: editedMessage,
    });

    editor.commands.setContent('');
    cancelEdition();
  };

  return (
    <ConversationEditInput
      editor={editor}
      InputComponent={InputComponent}
      onSend={onSend}
      cancelEdition={cancelEdition}
    />
  );
};
